import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule } from '@angular/forms';

import { InscriptionsRoutingModule } from './inscriptions-routing.module';
import { ExtranetComponent } from './extranet/extranet.component';
import { FormulaireComponent } from './formulaire/formulaire.component';

import { SharedPipeModule } from '../pipes/shared-pipe-module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    InscriptionsRoutingModule,
    SharedPipeModule
  ],
  exports: [
    FormulaireComponent,
  ],
  declarations: [FormulaireComponent, ExtranetComponent],
  providers: [],
})
export class InscriptionsModule { }
